export const password = {
  title: 'views-reset-pwd-email-title',
  desc: 'views-reset-pwd-password-desc',
  tryAgainBtn: {
    title: 'views-reset-pwd-email-again',
    show: false,
  },
  formWidth: '53%',
  formItems: [
    {
      field: 'password',
      type: 'password',
      maxlength: '20',
      label: 'views-reset-pwd-password-subtit1',
      errorMsg: '',
      errorShow: false,
      icon: 'off',
    },
    {
      field: 'confirmPassword',
      type: 'password',
      maxlength: '20',
      label: 'views-reset-pwd-password-subtit2',
      errorMsg: '',
      errorShow: false,
      icon: 'off',
    },
  ],
};
